"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var differenceOfParams_1 = require("./differenceOfParams");
/**
 * Can be curried to return a copy of an object sans params
 *
 * object1 = {
 *  keep: 1,
 *  lose: 2
 * }
 *
 * const copySansLose = copyWithoutParams('lose')
 *
 * const object2 = copySansLose(object1)
 *
 * returns {
 *  keep: 1
 * }
 *
 * @param { list of params to remove } paramsToStrip
 */
exports.copyWithoutParams = function () {
    var paramsToStrip = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        paramsToStrip[_i] = arguments[_i];
    }
    return function (obj) { return lodash_1.flow([
        lodash_1.keys,
        differenceOfParams_1.differenceOfParams.apply(void 0, paramsToStrip),
        lodash_1.partial(lodash_1.pick, obj)
    ])(obj); };
};
//# sourceMappingURL=copyWithoutParams.js.map